// ================================================================
// OO-CALCULATOR.JS - Non-Returnable Margin Calculator
// All DOM queries scoped within .oo-calculator-page
// ================================================================

// ============================================================
// CORE CALCULATION ENGINE
// ============================================================

function getInputs() {
  return {
    cost: parseFloat(document.getElementById('cost').value) || 0,
    salePrice: parseFloat(document.getElementById('salePrice').value) || 0,
    referralPct: (parseFloat(document.getElementById('referralPct').value) || 0) / 100,
    fbaFee: parseFloat(document.getElementById('fbaFee').value) || 0,
    testQty: parseInt(document.getElementById('testQty').value) || 1,
    refundRate: (parseFloat(document.getElementById('refundSlider').value) || 0) / 100,
    recoveryPct: (parseFloat(document.getElementById('recoverySlider').value) || 80) / 100,
  };
}

function calcScenario(cost, salePrice, referralPct, fbaFee, testQty, refundRate, recoveryPct) {
  var referralFee = salePrice * referralPct;
  var adminFee = Math.min(5, referralFee * 0.20);
  var unitsSold = Math.round(testQty * (1 - refundRate));
  var unitsRefunded = testQty - unitsSold;
  var totalInvestment = cost * testQty;

  // Revenue from sold units
  var revenue = unitsSold * salePrice;
  // Fees on sold units
  var soldFees = unitsSold * (referralFee + fbaFee);
  // FBA fee on refunded units (paid when shipped, not refunded)
  var refundedFbaFees = unitsRefunded * fbaFee;
  // Admin fee on refunds
  var refundAdminFees = unitsRefunded * adminFee;
  // Referral fee credit on refunds (you get most back)
  var referralCredit = unitsRefunded * (referralFee - adminFee);

  // STANDARD: product comes back, you recover some value
  var standardRecovery = unitsRefunded * cost * recoveryPct;
  var standardProfit = revenue - soldFees - totalInvestment - refundedFbaFees - refundAdminFees + standardRecovery;

  // NON-RETURNABLE: product doesn't come back, COGS lost
  var nonReturnProfit = revenue - soldFees - totalInvestment - refundedFbaFees - refundAdminFees;

  return {
    referralFee: referralFee,
    adminFee: adminFee,
    fbaFee: fbaFee,
    unitsSold: unitsSold,
    unitsRefunded: unitsRefunded,
    totalInvestment: totalInvestment,
    revenue: revenue,
    soldFees: soldFees,
    refundedFbaFees: refundedFbaFees,
    refundAdminFees: refundAdminFees,
    standardProfit: standardProfit,
    nonReturnProfit: nonReturnProfit,
    standardRecovery: standardRecovery,
    profitPerSoldUnit: salePrice - cost - referralFee - fbaFee,
  };
}

function syncRefund(val) {
  document.getElementById('refundSlider').value = val;
  document.getElementById('refundDisplay').textContent = val + '%';
  calculate();
}

function syncRecovery(val) {
  document.getElementById('recoverySlider').value = val;
  document.getElementById('recoveryDisplay').textContent = val + '%';
  calculate();
}

function fmt(n) {
  if (n < 0) return '-$' + Math.abs(n).toFixed(2);
  return '$' + n.toFixed(2);
}

function calculate() {
  var i = getInputs();
  var r = calcScenario(i.cost, i.salePrice, i.referralPct, i.fbaFee, i.testQty, i.refundRate, i.recoveryPct);

  // Fee breakdown
  document.getElementById('feeReferral').textContent = fmt(r.referralFee);
  document.getElementById('feeFba').textContent = fmt(r.fbaFee);
  document.getElementById('feeAdmin').textContent = fmt(r.adminFee);
  document.getElementById('feeTotalSold').textContent = fmt(r.referralFee + r.fbaFee);
  document.getElementById('feeTotalReturn').textContent = fmt(r.fbaFee + r.adminFee);

  // Results
  document.getElementById('resultStandard').textContent = fmt(r.standardProfit);
  document.getElementById('resultStandard').className = 'amount ' + (r.standardProfit >= 0 ? 'text-green' : 'text-red');
  document.getElementById('resultStandardDetail').textContent =
    r.unitsRefunded + ' return' + (r.unitsRefunded !== 1 ? 's' : '') + ', product comes back (' + (i.recoveryPct*100) + '% recovery)';

  document.getElementById('resultNonReturn').textContent = fmt(r.nonReturnProfit);
  document.getElementById('resultNonReturn').className = 'amount ' + (r.nonReturnProfit >= 0 ? 'text-green' : 'text-red');
  document.getElementById('resultNonReturnDetail').textContent =
    r.unitsRefunded + ' return' + (r.unitsRefunded !== 1 ? 's' : '') + ', nothing comes back';

  // Difference
  var diff = r.standardProfit - r.nonReturnProfit;
  var diffEl = document.getElementById('diffAmount');
  diffEl.textContent = fmt(diff);
  diffEl.className = 'mono bold ' + (diff > 0 ? 'text-red' : 'text-green');
  document.getElementById('diffDetail').textContent = diff > 0
    ? 'more profit lost in a non-returnable category'
    : 'no additional risk from non-returnable status';

  // Verdict
  var verdictEl = document.getElementById('verdict');
  var verdictText = document.getElementById('verdictText');
  var verdictDetail = document.getElementById('verdictDetail');

  if (r.nonReturnProfit <= 0) {
    verdictEl.className = 'verdict skip';
    verdictText.textContent = 'Skip This Deal';
    verdictDetail.textContent = 'Non-returnable scenario shows a loss. Move on to the next one.';
  } else if (r.nonReturnProfit < r.totalInvestment * 0.10) {
    verdictEl.className = 'verdict caution';
    verdictText.textContent = 'Proceed With Caution';
    verdictDetail.textContent = 'Margins are thin. Reduce test quantity or find a better price.';
  } else {
    verdictEl.className = 'verdict source';
    verdictText.textContent = 'Source It - But Test Smart';
    verdictDetail.textContent = 'Non-returnable profit is acceptable. Stick to recommended test quantities.';
  }

  // Per-Unit Economics
  var profitIfKept = i.salePrice - i.cost - r.referralFee - i.fbaFee;
  var stdLossPerReturn = i.fbaFee + r.adminFee - (i.cost * i.recoveryPct);
  var stdExpectedPerUnit = (1 - i.refundRate) * profitIfKept - i.refundRate * stdLossPerReturn;

  var nrLossPerReturn = i.cost + i.fbaFee + r.adminFee;
  var nrExpectedPerUnit = (1 - i.refundRate) * profitIfKept - i.refundRate * nrLossPerReturn;

  var minToAbsorbOne = profitIfKept > 0 ? Math.ceil(nrLossPerReturn / profitIfKept) + 1 : 999;

  var puRateEl = document.getElementById('puRateDisplay');
  var puStdEl = document.getElementById('puStandard');
  var puNrEl = document.getElementById('puNonReturn');
  var puAbsorbQtyEl = document.getElementById('puAbsorbQty');
  var puAbsorbLabelEl = document.getElementById('puAbsorbLabel');
  var puExplainEl = document.getElementById('puExplain');

  puRateEl.textContent = (i.refundRate * 100).toFixed(0) + '%';
  puAbsorbQtyEl.style.color = '';

  puStdEl.textContent = fmt(stdExpectedPerUnit);
  puStdEl.style.color = stdExpectedPerUnit > 0 ? '#6FCF97' : '#FF6B6B';

  puNrEl.textContent = fmt(nrExpectedPerUnit);
  puNrEl.style.color = nrExpectedPerUnit > 0 ? '#6FCF97' : nrExpectedPerUnit === 0 ? '#F2C94C' : '#FF6B6B';

  var ratePct = (i.refundRate * 100).toFixed(0);
  var perUnitGap = stdExpectedPerUnit - nrExpectedPerUnit;

  if (i.refundRate === 0) {
    puAbsorbQtyEl.textContent = 'N/A';
    puAbsorbLabelEl.textContent = 'No returns expected - both categories perform the same';
    puExplainEl.textContent = 'At 0% refunds there is no return risk. Standard and non-returnable categories produce identical per-unit profit of ' + fmt(profitIfKept) + '.';
  } else if (nrExpectedPerUnit > 0) {
    puAbsorbQtyEl.textContent = minToAbsorbOne + ' units';
    puAbsorbLabelEl.textContent = 'Minimum units to absorb 1 return (non-returnable)';
    puExplainEl.textContent = 'At ' + ratePct + '% refunds, non-returnable costs you ' + fmt(perUnitGap) + ' more per unit than standard. The difference is the recovery value you lose (' + fmt(i.cost * i.recoveryPct) + ' per return). You need at least ' + minToAbsorbOne + ' units in a non-returnable test so the sold-unit profits cover 1 actual return.';
  } else if (nrExpectedPerUnit === 0) {
    puAbsorbQtyEl.textContent = 'Break-even';
    puAbsorbLabelEl.textContent = 'Non-returnable breaks even at this refund rate';
    puExplainEl.textContent = 'At ' + ratePct + '% refunds, non-returnable is break-even while standard still earns ' + fmt(stdExpectedPerUnit) + ' per unit. The missing recovery value (' + fmt(i.cost * i.recoveryPct) + ' per return) is eating your entire margin.';
  } else {
    puAbsorbQtyEl.textContent = fmt(nrExpectedPerUnit) + ' loss';
    puAbsorbQtyEl.style.color = '#FF6B6B';
    puAbsorbLabelEl.textContent = 'Non-returnable loses money at this refund rate';
    if (stdExpectedPerUnit > 0) {
      puExplainEl.textContent = 'At ' + ratePct + '% refunds, standard category still profits ' + fmt(stdExpectedPerUnit) + ' per unit because you recover the product. Non-returnable loses ' + fmt(Math.abs(nrExpectedPerUnit)) + ' per unit because every return is a total write-off. This deal works in standard but not non-returnable.';
    } else {
      puExplainEl.textContent = 'At ' + ratePct + '% refunds, both categories lose money. This deal does not work at this refund rate regardless of category.';
    }
  }

  // Update sensitivity table
  buildSensitivity(i);

  // Update break-even
  calcBreakEven(i);

  // Update compare tab
  compareCalc();
}

// ============================================================
// SENSITIVITY TABLE
// ============================================================

function buildSensitivity(i) {
  var rates = [0, 0.03, 0.05, 0.08, 0.10, 0.15, 0.20, 0.25, 0.30, 0.40];
  var currentRate = i.refundRate;
  var tbody = document.getElementById('sensBody');
  tbody.innerHTML = '';

  rates.forEach(function(rate) {
    var r = calcScenario(i.cost, i.salePrice, i.referralPct, i.fbaFee, i.testQty, rate, i.recoveryPct);
    var diff = r.standardProfit - r.nonReturnProfit;
    var isCurrent = Math.abs(rate - currentRate) < 0.005;

    var tr = document.createElement('tr');
    if (isCurrent) tr.className = 'current-rate';
    tr.innerHTML =
      '<td>' + (rate * 100).toFixed(0) + '%</td>' +
      '<td>' + (i.testQty - Math.round(i.testQty * (1 - rate))) + '</td>' +
      '<td class="' + (r.standardProfit >= 0 ? 'profit' : 'loss') + '">' + fmt(r.standardProfit) + '</td>' +
      '<td class="' + (r.nonReturnProfit >= 0 ? 'profit' : 'loss') + '">' + fmt(r.nonReturnProfit) + '</td>' +
      '<td class="' + (diff > 0 ? 'loss' : 'profit') + '">' + fmt(diff) + '</td>';
    tbody.appendChild(tr);
  });
}

// ============================================================
// BREAK-EVEN RATE
// ============================================================

function calcBreakEven(i) {
  var breakRate = 0;
  for (var pct = 1; pct <= 100; pct++) {
    var rate = pct / 100;
    var r = calcScenario(i.cost, i.salePrice, i.referralPct, i.fbaFee, i.testQty, rate, i.recoveryPct);
    if (r.nonReturnProfit < 0) {
      breakRate = (pct - 1);
      break;
    }
    if (pct === 100) breakRate = 100;
  }

  var el = document.getElementById('breakEvenRate');
  el.textContent = breakRate + '%';
  el.className = 'mono bold';
  el.style.color = breakRate > 20 ? 'var(--green-dark)' : breakRate > 10 ? '#8B6914' : 'var(--red-dark)';

  var note = document.getElementById('breakEvenNote');
  if (breakRate > 25) {
    note.textContent = 'Strong buffer. This deal can absorb significant returns.';
  } else if (breakRate > 15) {
    note.textContent = 'Moderate buffer. Watch your refund rate closely.';
  } else if (breakRate > 0) {
    note.textContent = 'Thin margin for error. Any refund rate above ' + breakRate + '% and you lose money.';
  } else {
    note.textContent = 'This deal loses money before any returns. Check your numbers.';
  }
}

// ============================================================
// DEAL COMPARISON
// ============================================================

function compareCalc() {
  var deals = [1, 2, 3].map(function(n) {
    var cost = parseFloat(document.getElementById('d' + n + 'cost').value) || 0;
    var price = parseFloat(document.getElementById('d' + n + 'price').value) || 0;
    var ref = (parseFloat(document.getElementById('d' + n + 'ref').value) || 0) / 100;
    var fba = parseFloat(document.getElementById('d' + n + 'fba').value) || 0;
    var qty = parseInt(document.getElementById('d' + n + 'qty').value) || 1;
    var rate = (parseFloat(document.getElementById('d' + n + 'rate').value) || 0) / 100;

    var r = calcScenario(cost, price, ref, fba, qty, rate, 0.8);
    var investment = cost * qty;
    var roi = investment > 0 ? (r.nonReturnProfit / investment) * 100 : 0;

    return { n: n, profit: r.nonReturnProfit, roi: roi, investment: investment };
  });

  // Rank by ROI
  var sorted = deals.slice().sort(function(a, b) { return b.roi - a.roi; });
  var ranks = {};
  sorted.forEach(function(d, i) {
    ranks[d.n] = i === 0 ? 'best' : i === 1 ? 'ok' : 'worst';
  });
  var rankLabels = { best: '#1 Best ROI', ok: '#2', worst: '#3' };

  deals.forEach(function(d) {
    var profitEl = document.getElementById('d' + d.n + 'profit');
    profitEl.textContent = fmt(d.profit);
    profitEl.className = 'deal-result-val ' + (d.profit >= 0 ? 'text-green' : 'text-red');

    var roiEl = document.getElementById('d' + d.n + 'roi');
    roiEl.textContent = d.roi.toFixed(1) + '% ROI';
    roiEl.className = 'deal-result-roi ' + (d.roi >= 0 ? 'text-green' : 'text-red');

    var rankEl = document.getElementById('d' + d.n + 'rank');
    rankEl.textContent = rankLabels[ranks[d.n]];
    rankEl.className = 'deal-rank ' + ranks[d.n];
  });
}

// ============================================================
// TAB NAVIGATION
// ============================================================

function showTab(name, btn) {
  var container = document.querySelector('.oo-calculator-page');
  container.querySelectorAll('.tab-content').forEach(function(el) { el.classList.remove('active'); });
  container.querySelectorAll('.tab-btn').forEach(function(el) { el.classList.remove('active'); });
  document.getElementById('tab-' + name).classList.add('active');
  btn.classList.add('active');
}

// ============================================================
// QR CODE GENERATOR (placeholder)
// ============================================================

function generateQR() {
  var url = 'officialolsons.com/pages/margin-calculator';
  var container = document.getElementById('qrCode');
  container.innerHTML = '<div style="display:flex;flex-direction:column;align-items:center;gap:4px">' +
    '<svg viewBox="0 0 100 100" width="90" height="90">' +
    '<rect fill="#1B2A4A" x="5" y="5" width="25" height="25" rx="2"/>' +
    '<rect fill="white" x="9" y="9" width="17" height="17" rx="1"/>' +
    '<rect fill="#1B2A4A" x="13" y="13" width="9" height="9" rx="1"/>' +
    '<rect fill="#1B2A4A" x="70" y="5" width="25" height="25" rx="2"/>' +
    '<rect fill="white" x="74" y="9" width="17" height="17" rx="1"/>' +
    '<rect fill="#1B2A4A" x="78" y="13" width="9" height="9" rx="1"/>' +
    '<rect fill="#1B2A4A" x="5" y="70" width="25" height="25" rx="2"/>' +
    '<rect fill="white" x="9" y="74" width="17" height="17" rx="1"/>' +
    '<rect fill="#1B2A4A" x="13" y="78" width="9" height="9" rx="1"/>' +
    '<rect fill="#1B2A4A" x="35" y="5" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="45" y="5" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="55" y="5" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="35" y="15" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="50" y="15" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="60" y="15" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="40" y="25" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="55" y="25" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="35" y="35" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="45" y="35" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="55" y="35" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="70" y="35" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="85" y="35" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="40" y="45" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="60" y="45" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="75" y="45" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="90" y="45" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="35" y="55" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="50" y="55" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="65" y="55" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="80" y="55" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="5" y="55" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="15" y="55" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="40" y="65" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="55" y="65" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="70" y="65" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="85" y="65" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="35" y="75" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="50" y="75" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="65" y="75" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="80" y="75" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="40" y="85" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="55" y="85" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="70" y="85" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="90" y="85" width="5" height="5"/>' +
    '<rect fill="#1B2A4A" x="70" y="70" width="11" height="11" rx="1"/>' +
    '<rect fill="white" x="73" y="73" width="5" height="5" rx="1"/>' +
    '</svg>' +
    '<span style="font-size:0.6rem;color:var(--text-light)">Replace with<br>actual QR code</span>' +
    '</div>';
}

// ============================================================
// INIT
// ============================================================

window.addEventListener('DOMContentLoaded', function() {
  calculate();
  generateQR();
});
